import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=821ee0a4&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=ts"
export * from "./change-password.vue?vue&type=script&lang=ts"
import style0 from "./change-password.vue?vue&type=style&index=0&id=821ee0a4&lang=scss"
import style1 from "./change-password.vue?vue&type=style&index=1&id=821ee0a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ee0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('821ee0a4')) {
      api.createRecord('821ee0a4', component.options)
    } else {
      api.reload('821ee0a4', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=821ee0a4&scoped=true", function () {
      api.rerender('821ee0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/change-password.vue"
export default component.exports